<template>
  <el-popover
    placement="bottom-start"
    width="420"
    popper-class="popper-tree declare-dep"
    @hide="handledHide"
    trigger="click"
  >
    <el-tree
      :props="defaultProps"
      :data="treeData"
      show-checkbox
      node-key='id'
      ref="tree"
      highlight-current
      check-strictly
      :default-expanded-keys="expandedData"
      :render-after-expand="false"
      @check="handleCheckChange"
    >
    </el-tree>
    <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
  </el-popover>
</template>
<script>
import _ from 'lodash';
export default {
  name: 'DeptSelecter',
  props: {
    isDisabled: Boolean,
    deptInfo: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      department: '',
      departmentNo: '',
      expandedData: [],
    }
  },
  watch: {
    deptInfo: {
      handler(newVal) {
        this.department = newVal.department;
        this.departmentNo = newVal.departmentNo;
      },
      immediate: true,
    },
    department: {
      handler(val) {
        if(!val) {
          this.departmentNo = "";
          this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
        }
      },
      immediate:true
    }
  },
  methods: {
    findDeptIdByCode(code) {
      const findId = (deptArr = []) => {
        for (let i = 0; i < deptArr.length; i++) {
          const item = deptArr[i];
          if (item.code === code) {
            return item.id;
          }
          if (item.children && item.children.length > 0) {
            findId(item.children);
          }
        }
      }
      let id = findId(this.deptList);
      return id;
    },
    async getDep() {
      await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
        this.deptList = res.data || [];

        this.deptList.forEach(v => {
          const objClone = {};
          objClone.id = v.id;
          objClone.code = v.code;
          objClone.label = v.displayName;
          if (v.parentId === null) {
            this.expandedData.push(v.id);
            objClone.children = this.deptList.filter(t => t.parentId === v.id);
            this.generateMenu(objClone.children);
            this.treeData.push(objClone);
          }
        });
        this.$nextTick(() => {
          const id = this.findDeptIdByCode(this.departmentNo);
          this.$refs.tree.setCheckedKeys([id]);
        })
      });
    },

    handleCheckChange(data, checkInfo){
      if (checkInfo.checkedKeys.length === 2) {
        this.$refs.tree.setCheckedNodes([data]);
        this.departmentNo = data.code;
        this.department = this.getCompleteDept(data.id);
      } else if (checkInfo.checkedKeys.length === 1) {
        this.departmentNo = data.code;
        this.department = this.getCompleteDept(data.id);
      } else {
        this.departmentNo = '';
        this.department = '';
      }
      this.$emit('change', {department: this.department, departmentNo: this.departmentNo });
    },
    // 获取完整部门路径
    getCompleteDept(id) {
      if (!id) return 0;
      let completeDept = ''
      const getDeptNode = (deptId) => {
        const node = this.$refs.tree.getNode(deptId);
        if (!node || !node.parent) return;
        if (node && node.data) {
          if (completeDept) {
            completeDept = node.data.label + '\\' + completeDept;
          } else {
            completeDept = node.data.label;
          }
        }
        getDeptNode(node.parent.data.id);
      }
      getDeptNode(id);
      return completeDept;
    },
    getChildrenMenu(depData) {
      let depTree = [];
      depData.forEach(t => {
        if(t.label.indexOf(this.department) != -1){
          depTree.push(t)
        } else {
          if (t.children && t.children.length) {
            t.children = this.getChildrenMenu(t.children)
            if(t.children && t.children.length){
              depTree.push(t);
            }
          }
        }
      });
      return (this.treeData = depTree);
    },
    generateMenu(chs){
      chs.forEach(v => {
        v.label = v.displayName
        v.children = this.deptList.filter(t => t.parentId === v.id)
        this.generateMenu(v.children);
      });
    },
    handledHide() {
      this.$emit('hide');
    },
  },
  created() {
    this.deptList = [];
    this.getDep();
  },
}
</script>
<style lang="scss" scoped>
  
</style>